import script from "./FooterView.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterView.vue?vue&type=script&setup=true&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=456beeb3&lang=scss"

const __exports__ = script;

export default __exports__